const account_center = {
    not_enabled: 'مرکز حساب فعال نیست.',
    field_not_editable: 'فیلد قابل ویرایش نیست.',
    field_not_enabled: 'فیلد فعال نیست.',
};
export default Object.freeze(account_center);
